export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Грудь`, `46`, `50`, `52`, `55`, `58`, `61`],
  [`Длина`, `68`, `70`, `72`, `74`, `76`, `78`]
];
